import { render, staticRenderFns } from "./MultiSelectTag.vue?vue&type=template&id=3304b3c2&"
import script from "./MultiSelectTag.vue?vue&type=script&lang=js&"
export * from "./MultiSelectTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports